export default __webpack_public_path__ + "static/media/wecare-green-logo.4773d2f8.svg";